export default "__VITE_ASSET__DWoxZhdy__"